import { createSelector } from "reselect"
import { get, filter } from "lodash"
import { computeSelectedOption } from "helpers/analyze"
import { getFactorCategory, getCategories } from "modules/factor-trends/selectors/factors"
import { getCurrentRisk } from "./risk"
import { getDisplayCategories } from "./data"

const EMPTY_ARRAY = []

const getDefaultOption = createSelector(
  [getCurrentRisk],
  current => {
    if (!current) {
      return null
    }

    return {
      id: "all",
      color: "#00abe8",
      label: "All",
    }
  },
)

export const getOptions = createSelector(
  [getCurrentRisk, getCategories, getDisplayCategories, getDefaultOption],
  (current, categories, displayCategories, defaultOption) => {
    if (current) {
      const options = [
        defaultOption,
        ...categories
          .filter(category => !category.singleFactor)
          .map(category => {
            if (displayCategories.indexOf(category.id) === -1) return null

            const field = `categories.${category.id}`
            const value = get(current, field)

            return { value, ...category }
          }),
      ]

      return filter(options, option => option && !Number.isNaN(option.value))
    } else {
      return EMPTY_ARRAY
    }
  },
)

export const getSelectedOption = createSelector(
  [getOptions, getFactorCategory, getDefaultOption],
  computeSelectedOption,
)
